import { EventEmitter, Injectable, Output, Directive } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { EnvironmentService } from '@app/core/environment/environment.service';
import { ErrorService } from '@app/core/error/error.service';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { EntityCV } from '@app/shared/model/cv/EntityCV.model';
import { catchError } from 'rxjs/operators';
import { Season } from '../model/season.model';
import { AbstractEntityService } from '@app/shared/service/base/abstractEntityService';
import { EntityInterface } from '@app/shared/model/entity/interfaces/entityInterface.model';
import { ProcessProgress } from '@app/core/progress/ProcessProgress';

@Directive()
@Injectable({
  providedIn: 'root'
})
export class SeasonService extends AbstractEntityService {

  @Output() defaultSeasonChange = new EventEmitter<Season>();
  @Output() changeDataOfSeason = new EventEmitter<Season>();

  baseApiUrl = 'api';
  lastAndNextSeasonCodesUrl = 'LastAndNextSeasonCodes';
  createNextSeasonUrl = 'createNextSeason';

  defaultSeason: Season;

  constructor(
    public httpClient: HttpClient,
    public environmentService: EnvironmentService,
    public errorService: ErrorService,
    public router: Router) {
    super(httpClient, environmentService, router, errorService);
  }

  getEntityName(): string {
    return EntityCV.all.SEASON;
  }

  // getIdFromEntity(season: Season): any {
  //   return season.code;
  // }

  getURLIdFromEntity(season: Season): string {
    return season.code;
  }

  setDefaultSeason(season: Season): void {
    if (!this.defaultSeason || this.defaultSeason.code !== season.code) {
      const seasonString = JSON.stringify(season);
      localStorage.setItem('defaultSeason', seasonString);
      this.defaultSeason = season;
      this.defaultSeasonChange.emit(season);
    }
  }

  removeDefaultSeason(): void {
    localStorage.removeItem('defaultSeason');
    this.defaultSeason = null;
    this.defaultSeasonChange.emit(null);
}
  getDefaultSeason(): Season {
    if (this.defaultSeason) {
      return this.defaultSeason;
    } else {
      const seasonString = localStorage.getItem('defaultSeason');
      if (seasonString && seasonString !== 'null') {
        const season: Season = JSON.parse(seasonString);
        season.startDatetime = new Date(season.startDatetime);
        season.endDatetime = new Date(season.endDatetime);
        this.defaultSeason = season;
        return season;
      } else {
        return null;
      }
    }
  }


  public createNextSeason(code: string): Observable<ProcessProgress> {

    const urlApi = `${this.baseBackUrl}${this.baseApiUrl}/${this.getEntityName()}/${this.createNextSeasonUrl}/${code}`;

    return this.httpClient.post<ProcessProgress>(urlApi, {}, {headers: this.getHeaders()})
      // añadimos el manejo de errores
      .pipe(catchError((error: HttpErrorResponse) => this.handleError(error, true) ));
  }

  public getLastAndNextSeasonCodes(): Observable<any> {

    const urlApi = `${this.baseBackUrl}${this.baseApiUrl}/${this.getEntityName()}/${this.lastAndNextSeasonCodesUrl}`;

    return this.httpClient.get<any>(urlApi, {headers: this.getHeaders()})
      // añadimos el manejo de errores
     .pipe(catchError((error: HttpErrorResponse) => this.handleError(error, true, 'Error al recuperar datos de temporadas')));
  }

  // public startCreateProcess(code: string): Observable<ProcessProgress> {

  //   const urlApi = `${this.baseBackUrl}${this.baseApiUrl}/${this.getEntityName()}/StartCreateProcess/${code}`;

  //   return this.httpClient.get<ProcessProgress>(urlApi, {headers: this.getHeaders()})
  //     // añadimos el manejo de errores
  //    .pipe(catchError((error: HttpErrorResponse) => this.handleError(error, true, 'Error al crear la temporada')));
  // }

  public findAll(showError: boolean = true): Observable<EntityInterface[]> {
    // const urlApi = `${this.baseBackUrl}${this.baseApiUrl}/${this.getEntityName()}${specialist ? '/' + specialist : ''}`;
    const urlApi = `${this.baseBackUrl}${this.baseApiUrl}/${this.getEntityName()}`;
    return this.httpClient.get<EntityInterface[]>(urlApi, {headers: this.getHeaders()})
        // añadimos el manejo de errores
        .pipe(catchError((error: HttpErrorResponse) => this.handleError(error, showError, `entity.${this.getEntityName().charAt(0).toLowerCase() + this.getEntityName().slice(1)}.error.getAll`) ));
  }

  public updateConferenceModeData(code: string, conferenceMode: boolean, conferenceGi: string): Observable<void> {
    const urlApi = `${this.baseBackUrl}${this.baseApiUrl}/${this.getEntityName()}/updateConferenceModeData/${code}/${conferenceMode}/${conferenceGi}`;

    return this.httpClient.patch<void>(urlApi, {}, {headers: this.getHeaders()})
      // añadimos el manejo de errores
      .pipe(catchError((error: HttpErrorResponse) => this.handleError(error, true) ));
  }

}
